(function($, d, g) {
	
	'use strict';
    
    var ckKey = ("pmi_" + btoa("cookie_agreement")).replace(/=/g, "");
    var ckVal = encodeURIComponent(btoa("accepted"));
    var ckReject = encodeURIComponent(btoa("rejected"));
    
    var $popup;
    
    function setCookie(cname, cvalue, exhours) {
        var dt = new Date();
        dt.setTime(dt.getTime() + (exhours * 60 * 60 * 1000));
        var expires = "expires=" + dt.toUTCString();
        d.cookie = cname + "=" + cvalue + ";" + expires + ";";
    }
    function getCookie(cname) {
        var name = cname + "=";
        var ca = d.cookie.split(";");
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
    
    function acceptPolicy(e) {
        setCookie(ckKey, ckVal, 90 * 24);
        e.delegateTarget.style.display = "none";
    }

    function rejectPolicy(e) {
        setCookie(ckKey, ckReject, 24);
        e.delegateTarget.style.display = "none";
    }
	
	var init = function () {
        $popup = $(".cookie-popup");
        if ($popup.length && getCookie(ckKey) !== ckVal && getCookie(ckKey) !== ckReject) {
            $popup.show();
            $popup.on("click", ".cookie-accept-btn", acceptPolicy);
            $popup.on("click", ".cookie-reject-btn", rejectPolicy);
        }
	};
	
	$(init);
	
})(jQuery, document, window);
